module.exports = __webpack_public_path__ + "static/media/Mario_German_Fromow_Rangel.fd6c542e.png";